"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Analytics = function () {
  function Analytics() {
    _classCallCheck(this, Analytics);
  }

  _createClass(Analytics, null, [{
    key: "pageView",
    value: function pageView() {
      var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
      window.ga && (window.ga("set", "page", i), window.ga("send", "pageview"));
    }
  }, {
    key: "timing",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(i) {
        var n, e, _i;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                n = window.performance ? window.performance.now() : Date.now();
                _context.next = 3;
                return i(function (i, n) {
                  var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  var t = { hitType: "timing", timingCategory: i, timingVar: n };return e && (t.timingLabel = e), t;
                });

              case 3:
                e = _context.sent;
                if (window.ga && e) {
                  _i = (window.performance ? window.performance.now() : Date.now()) - n;
                  window.ga && (e.timingValue = _i, window.ga("send", e));
                }
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function timing(_x2) {
        return _ref.apply(this, arguments);
      }

      return timing;
    }()
  }, {
    key: "exception",
    value: function exception(i) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      window.ga && window.ga("send", "exception", { exDescription: i.toString(), exFatal: n });
    }
  }]);

  return Analytics;
}();

module.exports = Analytics;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFuYWx5dGljcy5qcyJdLCJuYW1lcyI6WyJBbmFseXRpY3MiLCJ1cmwiLCJ3aW5kb3ciLCJsb2NhdGlvbiIsImhyZWYiLCJnYSIsIltvYmplY3QgT2JqZWN0XSIsImZ1bmMiLCJzdGFydFRpbWVzdGFtcCIsInBlcmZvcm1hbmNlIiwibm93IiwiRGF0ZSIsInRpbWVPYmplY3QiLCJjYXRlZ29yeSIsInN1YmNhdGVnb3J5IiwibGFiZWwiLCJvYmoiLCJoaXRUeXBlIiwidGltaW5nQ2F0ZWdvcnkiLCJ0aW1pbmdWYXIiLCJ0aW1pbmdMYWJlbCIsIm1pbGxpc2Vjb25kcyIsInRpbWluZ1ZhbHVlIiwiZXgiLCJmYXRhbCIsImV4RGVzY3JpcHRpb24iLCJ0b1N0cmluZyIsImV4RmF0YWwiLCJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7OztJQUVNQSxTOzs7Ozs7OytCQUNvQ0k7QUFBQUEsVUFBdEJILENBQXNCRyx1RUFBaEJGLE9BQU9DLFFBQVBELENBQWdCRSxJQUFBQTtBQUMvQkYsYUFBT0csRUFBUEgsS0FDQ0EsT0FBT0csRUFBUEgsQ0FBVSxLQUFWQSxFQUFpQixNQUFqQkEsRUFBeUJELENBQXpCQyxHQUNBQSxPQUFPRyxFQUFQSCxDQUFVLE1BQVZBLEVBQWtCLFVBQWxCQSxDQUZEQTtBQU1QSTs7OzswRkFBb0JDLEM7Ozs7Ozs7QUFDWkMsaUIsR0FBaUJOLE9BQU9PLFdBQVBQLEdBQXFCQSxPQUFPTyxXQUFQUCxDQUFtQlEsR0FBbkJSLEVBQXJCQSxHQUFnRFMsS0FBS0QsR0FBTEMsRTs7dUJBRTlDSixFQUFLLFVBQUNNLENBQUQsRUFBV0MsQ0FBWCxFQUFnQztBQUFBLHNCQUFSQyxDQUFRLHVFQUFBLElBQUE7QUFDeEQsc0JBQUlDLElBQUFBLEVBQ0FDLFNBQVMsUUFEVEQsRUFFQUUsZ0JBQWdCTCxDQUZoQkcsRUFHQUcsV0FBV0wsQ0FIWEUsRUFBSixDQVVBLE9BSkdELE1BQ0NDLEVBQUlJLFdBQUpKLEdBQWtCRCxDQURuQkEsR0FJSUMsQ0FBUDtBQUFPQSxpQkFYWVQsQzs7O0FBQW5CSyxpQjtBQWNKLG9CQUFHVixPQUFPRyxFQUFQSCxJQUNJVSxDQURQLEVBQ21CO0FBR1BTLG9CQUhPLEdBR1BBLENBRmVuQixPQUFPTyxXQUFQUCxHQUFxQkEsT0FBT08sV0FBUFAsQ0FBbUJRLEdBQW5CUixFQUFyQkEsR0FBZ0RTLEtBQUtELEdBQUxDLEVBRS9EVSxJQUE4QmIsQ0FIdkI7QUFLUk4seUJBQU9HLEVBQVBILEtBQ0NVLEVBQVdVLFdBQVhWLEdBQXlCUyxFQUF6QlQsRUFFQVYsT0FBT0csRUFBUEgsQ0FBVSxNQUFWQSxFQUFrQlUsQ0FBbEJWLENBSERBO0FBR21CVTs7Ozs7Ozs7Ozs7Ozs7Ozs7OEJBTWpCVyxDLEVBQVk7QUFBQSxVQUFSQyxDQUFRLHVFQUFSQSxDQUFRLENBQUE7QUFDdEJ0QixhQUFPRyxFQUFQSCxJQUNDQSxPQUFPRyxFQUFQSCxDQUFVLE1BQVZBLEVBQ0ksV0FESkEsRUFDSSxFQUNJdUIsZUFBZUYsRUFBR0csUUFBSEgsRUFEbkIsRUFFSUksU0FBU0gsQ0FGYixFQURKdEIsQ0FEREE7QUFJa0JzQjs7Ozs7O0FBTTdCSSxPQUFPQyxPQUFQRCxHQUFpQjVCLFNBQWpCNEIifQ==